import type { IRulesModalResources } from "@/src/cashback/RuleModal.Resources";

export const RulesModalResourcesEn: IRulesModalResources = {
    legalInfo: [
        "You are leaving the goodie.pl website. On the new Partner's site, you will be bound by a new Terms and Conditions and Privacy Policy.",
        "The Partner is responsible for the sales offer.",
    ],
    title: "You are going to the shop",
    shortText: "Remember!",
    btnNext: "Go to",
    btnCancel: "Cancel",
};
